export default class ErrorWithContext extends Error {
  responseBody: any

  responseStatus: number

  constructor(message: string, { responseBody, responseStatus }: { responseBody?: any; responseStatus?: number } = {}) {
    super(message)
    if (responseBody || responseStatus) {
      this.responseBody = responseBody
      this.responseStatus = responseStatus
    }
  }
}